<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/brand/white.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
                        <img src="img/brand/blue.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">Works</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <router-link to="/books" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-books"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">個人誌</h6>
                                <p class="description d-none d-md-inline-block mb-0">雛菊書房で今まで発行された個人誌（主に二次創作）
                                のリストはこちら。</p>
                            </div>
                        </router-link>
                        <router-link to="/anthologies" class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="fa fa-users"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">合同誌・アンソロジー</h5>
                                <p class="description d-none d-md-inline-block mb-0">雛菊書房が主催として発行した合同誌及びアンソロジー
                                のリスとはこちら。</p>
                            </div>
                        </router-link>
                    </div>
                </base-dropdown>
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                  <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                    <i class="ni ni-ui-04 d-lg-none"></i>
                    <span class="nav-link-inner--text">Events</span>
                  </a>
                  <div class="dropdown-menu-inner">
                    <router-link to="/events" class="media d-flex align-items-center">
                      <div class="icon icon-shape bg-gradient-danger rounded-circle text-white">
                        <i class="ni ni-calendar-grid-58"></i>
                      </div>
                      <div class="media-body ml-3">
                        <h6 class="heading text-danger mb-md-1">即売会参加情報</h6>
                        <p class="description d-none d-md-inline-block mb-0">直近の即売会参加情報、過去の参加情報及び今後参加する
                        予定/申込中の即売会のリストはこちら。</p>
                      </div>
                    </router-link>
                    <!--<router-link to="/landing" class="media d-flex align-items-center">
                      <div class="icon icon-shape bg-gradient-info rounded-circle text-white">
                        <i class="ni ni-single-copy-04"></i>
                      </div>
                      <div class="media-body ml-3">
                        <h5 class="heading text-info mb-md-1">合同誌・アンソロジー企画など</h5>
                        <p class="description d-none d-md-inline-block mb-0">雛菊書房として現在企画中の合同誌、アンソロジーその他
                        企画の一覧などはこちら。</p>
                      </div>
                    </router-link>-->
                  </div>
                </base-dropdown>
                <li class="nav-item">
                  <router-link to="/news" class="nav-link"><i class="fa fa-bell d-lg-none"> </i>News</router-link>
                </li>
              <li class="nav-item">
                <router-link to="/faq" class="nav-link"><i class="fa fa-question-circle d-lg-none"> </i>FAQ</router-link>
              </li>
                <li class="nav-item">
                  <router-link to="/contact" class="nav-link"><i class="fa fa-question-circle d-lg-none"> </i>Contact</router-link>
                </li>
                <li class="nav-item">
                  <a href="https://hinagiku-books.fanbox.cc/" class="nav-link" target="_blank" rel="noopener"><i class="ni ni-collection d-lg-none"> </i>Blog(FANBOX)</a>
                </li>
                <li class="nav-item">
                  <a href="https://hinagiku-books.booth.pm/" class="nav-link" target="_blank" rel="noopener"><i class="ni ni-basket d-lg-none"> </i>Shop(BOOTH)</a>
                </li>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://twitter.com/HinagikuBooks" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Follow us on Twitter">
                        <i class="fa fa-twitter-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Twitter</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
